import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const useCandidateProfileFeatureFlags = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  return {
    canDisplayChangeLogs: checkIfFeatureFlagEnabled(FeatureFlags.ChangeLogCandidate),
    canExecuteCandidateAssignmentSheet: checkIfFeatureFlagEnabled(
      FeatureFlags.CandidateDataSheetFlow
    ),
    canOrganizeTabs: checkIfFeatureFlagEnabled(FeatureFlags.OrganizeTabsCandidateProfile),
    canUseNavigationControls: checkIfFeatureFlagEnabled(FeatureFlags.ProfileNavigationControls),
    canUseUrgencyVerification: checkIfFeatureFlagEnabled(FeatureFlags.UrgencyVerification),
    isAddDailyPlanTaskEnabled: checkIfFeatureFlagEnabled(FeatureFlags.DailyPlanAddTaskFromProfile),
    shouldShowKeywordTags: checkIfFeatureFlagEnabled(FeatureFlags.CandidateKeywordTags)
  };
};
